// src/app/directives/link-click.directive.ts
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appLinkClick]' // Apply this directive using appLinkClick attribute
})
export class LinkClickDirective {
  private isCtrlPressed: boolean = false;

  constructor(private readonly el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}

  // Listen for Ctrl/Cmd key down
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control' || event.metaKey) { // `metaKey` is for Cmd on Mac
      this.isCtrlPressed = true;
    }
  }

  // Listen for Ctrl/Cmd key up
  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control' || event.metaKey) {
      this.isCtrlPressed = false;
    }
  }

  // Listen for click events on the input/textarea
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.isCtrlPressed) {
      const inputElement = this.el.nativeElement;
      const text = inputElement.value;
      const cursorPosition = inputElement.selectionStart || 0; // Get the cursor position after click

      // Basic regex to find URLs (http/https or www. followed by non-space characters)
      // This regex might need to be more robust depending on your needs.
      const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/gi;

      let match;
      let clickedUrl: string | null = null;

      // Iterate through all found URLs to see if the click position is within one
      while ((match = urlRegex.exec(text)) !== null) {
        const urlStart = match.index;
        const urlEnd = match.index + match[0].length;

        // Check if the cursor position falls within the detected URL
        if (cursorPosition >= urlStart && cursorPosition <= urlEnd) {
          clickedUrl = match[0];
          break; // Found the URL at the click position
        }
      }

      if (clickedUrl) {
        // Prevent default browser behavior (like placing the cursor)
        event.preventDefault();
        event.stopPropagation(); // Stop event from bubbling up

        // Ensure the URL has a protocol for window.open, especially for 'www.' links
        if (clickedUrl.startsWith('www.') && !clickedUrl.startsWith('http')) {
          clickedUrl = 'https://' + clickedUrl;
        }

        window.open(clickedUrl, '_blank'); // Open the URL in a new tab
        this.isCtrlPressed = false; // Reset state after opening link
      }
    }
  }
}